import React, { useEffect, useRef, useState } from "react";
import { Overlay, Popover, Col, Row, Form } from "react-bootstrap";
import filter from "../../../assets/images/filt.svg";
import close from "../../../assets/images/close.svg";
import { filterDateFormat } from "../../../actions";
import { DatePicker } from "antd";
import moment from "moment";
import "antd/dist/antd.css";


function OaFilter(props) {
    const [cur, setCur] = useState("");
    const [eff, setEff] = useState("");
    const { onSubmit, reset, handleClose } = props;
    const ref = useRef(null);

    const effHandler = (val) => {
        setCur(filterDateFormat(val._d));
    }
    const currentHandler = (val) => {
        setEff(filterDateFormat(val._d));
    }

    const submitHandler = (e) => {
        e.preventDefault();
        let data = {
            "fromDate": eff,
            "toDate": cur
        }
        onSubmit(data);
    }

    const resetHandler = () => {
        reset();
        setCur("");
        setEff("");
    }

    const disabledDate = (current) => current && current > moment().endOf("day");
    const checkDisabledDate = (current) => (current && current > moment().endOf("day")) || moment(eff).endOf('day') > current;

    return (
        <div ref={ref} className="filter-background">
            <button onClick={props.handleClick} className="filter-button">
                <img src={filter} alt="..." width="18px" style={{ paddingRight: "5px" }} /> Filter
            </button>

            <Overlay
                show={props.show}
                target={props.target}
                placement="bottom"
                container={ref}
                containerPadding={20}
            >
                <Popover id="popover-contained">
                    <Popover.Header>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <p style={{ margin: 0 }}>Custom Date</p>
                            <img
                                src={close}
                                alt="Close"
                                width="16px"
                                style={{ cursor: "pointer", marginLeft: 'auto' }}
                                onClick={resetHandler}
                            />
                        </div>
                    </Popover.Header>
                    <Popover.Body>

                        <div className="filter-page">
                            <Form onSubmit={submitHandler}>
                                <Form.Group controlId="formBasicDate">
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        placeholder={eff !== "" ? eff : "From Date"}
                                        className="form-control"
                                        onChange={currentHandler}
                                        disabledDate={disabledDate}
                                    />
                                </Form.Group><br></br>
                                <Form.Group controlId="formBasicDate">
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        placeholder={cur !== "" ? cur : "To Date"}
                                        className="form-control"
                                        onChange={effHandler}
                                        disabledDate={disabledDate}

                                    />
                                </Form.Group>

                                <div>
                                    <Row>
                                        <Col md={6}>
                                            <button className="modal-price reset" type="button" onClick={resetHandler}>
                                                Reset</button>
                                        </Col>
                                        <Col md={6}>
                                            <button type="submit" className="modal-btn modal-apply">
                                                Apply
                                            </button>
                                        </Col>
                                    </Row>

                                </div>
                            </Form>
                        </div>
                    </Popover.Body>
                </Popover>
            </Overlay>
        </div>
    );
}


export default OaFilter;


